/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', this.onClickHandler.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.onClickHandler(event);
        }
      });
    }
    onClickHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      const index = this.dataset.index;
      const id = this.dataset.id;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0', id);
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index, id } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
